import React from "react";
import PropTypes from "prop-types";
import "./TooltipTextArea.css"; // Create a separate CSS file for styling if needed

const TooltipTextArea = ({ id, label, value, onChange, placeholder, required }) => {
  return (
    <div className="input-container">
      <label htmlFor={id} className="visually-hidden">{label}</label>
      <textarea
        id={id}
        placeholder={placeholder}
        value={value}
        required={required}
        onChange={(e) => onChange(e.target.value)}
        onFocus={(e) => e.target.nextSibling.classList.add("visible")}
        onBlur={(e) => e.target.nextSibling.classList.remove("visible")}
      />
      <span className="tooltip">{label}</span>
    </div>
  );
};


TooltipTextArea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default TooltipTextArea;
